import { render, staticRenderFns } from "./left-col.vue?vue&type=template&id=151b4484&scoped=true&"
import script from "./left-col.vue?vue&type=script&lang=js&"
export * from "./left-col.vue?vue&type=script&lang=js&"
import style0 from "./left-col.vue?vue&type=style&index=0&id=151b4484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151b4484",
  null
  
)

export default component.exports